import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Notifications from 'vue-notification'
import MiniBasket from '../components/MiniBasket.vue';
import Router from "../components/Router.vue";

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});
Vue.use(Notifications);

const router = Router;

new Vue({
    router,
    render: function (h) {
        return h(MiniBasket);
    },
    el: '#mini-basket',
    data: {
    },
    components: {
        MiniBasket
    },
    created() {
        this.$cookies.config('30d');
    },
    renderError (h, err) {
        return h('pre', { style: { color: 'red' }}, err.stack)
    }
});
